import KLayout from './KLayout.vue'
import KIdentity from './KIdentity.vue'

export {
  KLayout,
  KIdentity
}
